/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Event_Groups_RestoredInputs */

const en_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event groups restored successfully`)
};

const fr_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupes d’événements restaurés avec succès`)
};

const de_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen erfolgreich wiederhergestellt`)
};

const it_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppi di eventi ripristinati correttamente`)
};

const ru_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группы событий успешно восстановлены.`)
};

const es_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos restaurados exitosamente`)
};

const zh_cn2_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组已成功恢复`)
};

const ja_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループが正常に復元されました`)
};

const hi_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह सफलतापूर्वक पुनर्स्थापित हो गए।`)
};

const pt_pt2_automatic_save_event_groups_restored = /** @type {(inputs: Automatic_Save_Event_Groups_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos restaurados com sucesso`)
};

/**
* | output |
* | --- |
* | "Event groups restored successfully" |
*
* @param {Automatic_Save_Event_Groups_RestoredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_event_groups_restored = /** @type {((inputs?: Automatic_Save_Event_Groups_RestoredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Event_Groups_RestoredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_event_groups_restored(inputs)
	if (locale === "de") return de_automatic_save_event_groups_restored(inputs)
	if (locale === "it") return it_automatic_save_event_groups_restored(inputs)
	if (locale === "ru") return ru_automatic_save_event_groups_restored(inputs)
	if (locale === "es") return es_automatic_save_event_groups_restored(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_event_groups_restored(inputs)
	if (locale === "ja") return ja_automatic_save_event_groups_restored(inputs)
	if (locale === "hi") return hi_automatic_save_event_groups_restored(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_event_groups_restored(inputs)
	return en_automatic_save_event_groups_restored(inputs)
});